import type { IPlotlyElement } from '@chainlit/react-client';

import { PlotlyElement } from '@/components/Elements/Plotly';

interface Props {
  items: IPlotlyElement[];
}

const InlinedPlotlyList = ({ items }: Props) => (
  <div className="flex flex-col gap-2">
    {items.map((element, i) => {
      return (
        // Full width, like the data table beside it. `max-w-[600px]` with
        // `maxWidth: fit-content` shrink-wrapped the container to its content's
        // intrinsic width, and a ChartCard is fluid (width:100%) — so the
        // container collapsed to the width of its own toolbar and the plot came
        // out the size of a thumbnail.
        <div key={i} className="inline-plotly-container w-full min-w-0">
          <PlotlyElement element={element} />
        </div>
      );
    })}
  </div>
);

export { InlinedPlotlyList };
